<template>
  <div class="footer">
    江苏传智播客教育科技股份有限公司
    <br />Copyright 2006-{{new Date().getFullYear()}}， All Rights Reserved
    <br /> 
    <a
      :href="info.beian_miit_url"
      rel="noreferrer"
      target="_blank"
      >{{info.beian_miit_name}}</a>

    <br />
    <img src="../../../assets/coursePage/common/beian.png" alt />
    <a
        :href="info.beian_mps_url"
        rel="noreferrer"
        target="_blank"
        >{{info.beian_mps_name}}</a>

  </div>
</template>

<script>
import { domainInfo } from "../../../api/index.js";
export default {
   data() {
    let that = this;
    return {
        info:{
          beian_miit_name:'',
          beian_miit_url:'',
          beian_mps_name:'',
          beian_mps_url:''
        },
        from:''
    }
  },
  mounted(){
   this.getdomainInfo()
  },
  created(){
  
  },
   methods: {
    getdomainInfo(){
       domainInfo()
        .then((res) => {
          if (res.status==200) {
             this.from=this.getQueryString("from")
             var parentDomain = window.location.href; // 获取完整的URL
              var domain = new URL(parentDomain).hostname; // 解析出域名
              console.log(domain,'输出父级域名'); // 输出域名
              if(domain.indexOf('boxuegu.com')<=-1){
                this.info = res.data.result;
              } else{
                this.info={
                  beian_miit_name:'苏ICP备16007882号-12',
                  beian_miit_url:'https://beian.miit.gov.cn/',
                  beian_mps_name:'苏公网安备32132202001054号',
                  beian_mps_url:'https://beian.mps.gov.cn/#/query/webSearch?code=32132202001054'
                }
             }

          }
        })
        .finally(() => {});
    }
   }
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 60px 0px;
  width: 100%;
  background: #fff;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 40px;
  a {
      color: #4e5969;
  }
  img {
      width: 22px;
      vertical-align: middle;
      margin-right: 4px;
  }

}
</style>